import React from 'react';
export const Footer = () => {
  return <footer className="py-12 bg-darker border-t border-white/5 text-center px-4" data-id="element-24">
      <div className="container mx-auto max-w-4xl" data-id="element-25">
        <p className="text-gray-500 text-sm mb-4" data-id="element-26">
          © {new Date().getFullYear()} Efectivo Inmediato. Todos los derechos
          reservados.
        </p>
        <p className="text-gray-600 text-xs leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-27">
          Descargo de responsabilidad: Los resultados mencionados no son típicos
          y pueden variar según el esfuerzo, la dedicación y la capacidad de
          ejecución de cada individuo. Este producto no garantiza ingresos, sino
          que provee una metodología educativa.
        </p>
        <div className="flex justify-center gap-6 text-sm text-gray-500" data-id="element-28">
          <a href="#" className="hover:text-neon transition-colors" data-id="element-29">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-neon transition-colors" data-id="element-30">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-neon transition-colors" data-id="element-31">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
};